import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checked",
  "use": "icon-checked-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-checked\"><path d=\"M512 0C227.556 0 0 227.556 0 512s227.556 512 512 512 512-227.556 512-512S796.444 0 512 0zm324.267 415.289L449.422 802.133l-256-250.31c-22.755-22.756-22.755-56.89 0-79.645s56.89-22.756 79.645 0l170.666 170.666 307.2-307.2c22.756-22.755 56.89-22.755 79.645 0s22.755 56.89 5.689 79.645z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol